'use strict';

blocks.register('waf-action_Lookup-Details', function () {
    return {
        link: function link($block) {
            var systemRows = $block.find('#LinkedForm_LookupComposition .data-row').filter(function () {
                return $(this).find('input[name$="_IsSystem"][value="1"]').length === 1;
            });

            systemRows.find('input[name$="_Value"], input[name$="_Code"]').prop('readonly', true);

            systemRows.find('.remove-command-col .checkbox-control').hide();
        }
    };
});